// extracted by mini-css-extract-plugin
module.exports = {"player_quiz_box":"styles_player_quiz_box__2mNC-","player_quiz_box__nodata":"styles_player_quiz_box__nodata__3tGOZ"};